/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Heading_TaglineInputs */

const en_experience_heading_tagline = /** @type {(inputs: Experience_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A synchronized record of shipped work`)
};

const ar_experience_heading_tagline = /** @type {(inputs: Experience_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل متزامن للأعمال التي أطلقتها`)
};

const bn_experience_heading_tagline = /** @type {(inputs: Experience_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেলিভার করা কাজের ধারাবাহিক হিসাব`)
};

const de_experience_heading_tagline = /** @type {(inputs: Experience_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein synchronisiertes Protokoll ausgelieferter Arbeit`)
};

const es_experience_heading_tagline = /** @type {(inputs: Experience_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un registro sincronizado del trabajo publicado`)
};

const fr_experience_heading_tagline = /** @type {(inputs: Experience_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un journal synchronisé du travail livré`)
};

const pt_experience_heading_tagline = /** @type {(inputs: Experience_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um registro sincronizado do trabalho publicado`)
};

const zh_experience_heading_tagline = /** @type {(inputs: Experience_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发送工作的同步记录`)
};

const tr_experience_heading_tagline = /** @type {(inputs: Experience_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sevk edilen işin senkronize edilmiş kaydı`)
};

const ru_experience_heading_tagline = /** @type {(inputs: Experience_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизированный отчет об отправленных работах`)
};

const pl_experience_heading_tagline = /** @type {(inputs: Experience_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zsynchronizowany zapis wysłanej pracy`)
};

/**
* | output |
* | --- |
* | "A synchronized record of shipped work" |
*
* @param {Experience_Heading_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_heading_tagline = /** @type {((inputs?: Experience_Heading_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Heading_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_heading_tagline(inputs)
	if (locale === "bn") return bn_experience_heading_tagline(inputs)
	if (locale === "de") return de_experience_heading_tagline(inputs)
	if (locale === "es") return es_experience_heading_tagline(inputs)
	if (locale === "fr") return fr_experience_heading_tagline(inputs)
	if (locale === "pt") return pt_experience_heading_tagline(inputs)
	if (locale === "zh") return zh_experience_heading_tagline(inputs)
	if (locale === "tr") return tr_experience_heading_tagline(inputs)
	if (locale === "ru") return ru_experience_heading_tagline(inputs)
	if (locale === "pl") return pl_experience_heading_tagline(inputs)
	return en_experience_heading_tagline(inputs)
});